/**
 * Billboard adapter — per-type import adapter for 'billboard' media type.
 *
 * Required columns (in addition to COMMON_REQUIRED_COLUMNS):
 * - 'Szerokosc [m]' (width)
 * - 'Wysokosc [m]' (height)
 * - 'Material'
 * - 'Oswietlenie'
 */
import type { MediaUnitImportAdapter } from './types.js';
import {
  buildBaseRow,
  validateWidthHeightMaterialLighting,
  COMMON_REQUIRED_COLUMNS,
  COMMON_OPTIONAL_COLUMNS,
} from './parse-row.helper.js';

const REQUIRED_COLUMNS = [
  ...COMMON_REQUIRED_COLUMNS,
  'Typ nośnika',
  'Szerokość [m]',
  'Wysokość [m]',
  'Materiał',
  'Oświetlenie',
] as const;

const OPTIONAL_COLUMNS = [...COMMON_OPTIONAL_COLUMNS] as const;

export const billboardAdapter: MediaUnitImportAdapter = {
  mediaType: 'billboard',
  requiredColumns: REQUIRED_COLUMNS,
  optionalColumns: OPTIONAL_COLUMNS,

  validate: validateWidthHeightMaterialLighting,

  parseRow(row) {
    return buildBaseRow(row, 'billboard');
  },
};
